import { GreeksFormatter } from '@shared/commons/cache/OptionMaster/OptionTrader/GreeksFormatter';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { PositionItem } from '../PositionItem';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
export class OptionPositionItem extends PositionItem {
    constructor(optionTrader, position, sessionSettings, isNetQty) {
        super(position, sessionSettings, isNetQty);
        this._optionTrader = optionTrader;
    }
    GetColumnParams(column) {
        const columnParams = super.GetColumnParams(column);
        switch (column) {
            case PositionItem.DELTA_COL_INDEX:
            case PositionItem.GAMMA_COL_INDEX:
            case PositionItem.VEGA_COL_INDEX:
            case PositionItem.THETA_COL_INDEX:
            case PositionItem.IV_COL_INDEX:
            case PositionItem.RHO_COL_INDEX:
                columnParams.Hidden = false;
                columnParams.aggregateVisibility = TableTotalsVisibility.All;
                break;
        }
        return columnParams;
    }
    getColumnValue(column, useAccCurrency = null) {
        let value = super.getColumnValue(column, useAccCurrency);
        const sign = this.FPosition.BuySell === OperationType.Buy ? 1 : -1;
        switch (column) {
            case PositionItem.DELTA_COL_INDEX:
                value = GreeksFormatter.roundGreek(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).delta *
                    this.FPosition.Amount *
                    sign);
                break;
            case PositionItem.GAMMA_COL_INDEX:
                value = GreeksFormatter.roundGreek(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).gamma *
                    this.FPosition.Amount *
                    sign);
                break;
            case PositionItem.VEGA_COL_INDEX:
                value = GreeksFormatter.roundGreek(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).vega *
                    this.FPosition.Amount *
                    sign);
                break;
            case PositionItem.THETA_COL_INDEX:
                value = GreeksFormatter.roundGreek(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).theta *
                    this.FPosition.Amount *
                    sign);
                break;
            case PositionItem.IV_COL_INDEX:
                value = GreeksFormatter.roundIV(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).ivPercent);
                break;
            case PositionItem.RHO_COL_INDEX:
                value = GreeksFormatter.roundGreek(this._optionTrader.getGreeks(this.FPosition.Instrument.PutCall, this.FPosition.Instrument, this.FPosition.CurPriceClose).rho *
                    this.FPosition.Amount *
                    sign);
                break;
        }
        return value;
    }
    getColumnData(column) {
        const data = super.getColumnData(column);
        switch (column) {
            case PositionItem.DELTA_COL_INDEX:
            case PositionItem.GAMMA_COL_INDEX:
            case PositionItem.VEGA_COL_INDEX:
            case PositionItem.THETA_COL_INDEX:
            case PositionItem.RHO_COL_INDEX:
                data.FormattedValue = GreeksFormatter.formatGreek(data.Value);
                break;
            case PositionItem.IV_COL_INDEX:
                data.FormattedValue = GreeksFormatter.formatIV(data.Value);
                break;
        }
        return data;
    }
    getFormatTotalValue(column, value, totalCurrencyAfterFiltration = null) {
        switch (column) {
            case PositionItem.DELTA_COL_INDEX:
            case PositionItem.GAMMA_COL_INDEX:
            case PositionItem.VEGA_COL_INDEX:
            case PositionItem.THETA_COL_INDEX:
            case PositionItem.RHO_COL_INDEX:
                return GreeksFormatter.formatGreek(value);
            case PositionItem.IV_COL_INDEX:
                return GreeksFormatter.formatIV(value);
            default:
                return super.getFormatTotalValue(column, value, totalCurrencyAfterFiltration);
        }
    }
    getTotalValuePrecision(column, totalCurrencyAfterFiltration) {
        switch (column) {
            case PositionItem.DELTA_COL_INDEX:
            case PositionItem.GAMMA_COL_INDEX:
            case PositionItem.VEGA_COL_INDEX:
            case PositionItem.THETA_COL_INDEX:
            case PositionItem.RHO_COL_INDEX:
                return GreeksFormatter.GREEKS_PERCISION;
            case PositionItem.IV_COL_INDEX:
                return GreeksFormatter.IV_PERCISION;
            default:
                return super.getTotalValuePrecision(column, totalCurrencyAfterFiltration);
        }
    }
}
